<template>
  <b-row class="company-settings-page my-3">
    <b-col cols="12" md="10" offset-md="1" xl="8" offset-xl="2">
      <b-media class="mb-3" right-align>
        <template v-slot:aside v-if="company && company.siteBranding && company.siteBranding.smallLogo && company.siteBranding.smallLogo.fileLocation">
          <b-img height="32" width="32" :src="company.siteBranding.smallLogo.fileLocation"/>
        </template>
        <h3>Settings</h3>
        <p>Adjust preferences, branding &amp; other settings here.</p>
      </b-media>

      <b-alert class="d-flex flex-column justify-content-center align-items-center mb-3" show variant="warning" v-if="!isEnglishLang">
        {{ $t('status.page-only-in-english') }}
      </b-alert>

      <no-ssr>
        <b-tabs pills lazy :vertical="isWindowSM" v-model="tabIndex">
          <b-tab v-for="tab in tabs" :key="tab.path" :title="tab.label" :disabled="tab.disabled">
            <!-- Let the data drive the UI of your application https://github.com/vuejs/Discussion/issues/254#issuecomment-121279001 -->
            <component :is="tab.component"/>
          </b-tab>
        </b-tabs>
      </no-ssr>
    </b-col>
  </b-row>
</template>

<script>
import gridMixin from '@src/mixins/grid';
import { mapRoot } from '@src/mixins/root';

export default {
  name: 'CompanySettings',
  mixins: [
    gridMixin,
  ],
  data: () => ({
    tabIndex: -1,
  }),
  created() {
    this.setTabFromRoute();
  },
  metaInfo: {
    title: 'Settings',
  },
  computed: {
    ...mapRoot([ 'company', 'isRecruiterAdmin', 'isEnglishLang', 'departmentLabelPlural' ]),
    tabs() {
      const { handle } = this.company;
      const ALLOWED_SLACK = [
        'real-links',
        'recharge',
        'ocadogroup',
        'storyblok',
      ];

      const tabs = [
        {
          label: 'Preferences',
          path: '/preferences',
          component: () => import('@/views/settings/Preferences'),
        },
        {
          label: 'Branding',
          path: '/branding',
          component: () => import('@/views/settings/Branding'),
        },
        {
          label: 'Sign Up & Onboarding',
          path: '/onboarding',
          component: () => import('@/views/settings/Onboarding'),
        },
        {
          label: 'Emails',
          path: '/emails',
          component: () => import('@/views/settings/Emails'),
        },
        {
          label: this.departmentLabelPlural || 'Departments',
          path: '/departments',
          component: () => import('@/views/settings/Departments'),
        },
        {
          label: 'Gamification',
          path: '/gamification',
          component: () => import('@/views/settings/Gamification'),
        },
        {
          label: 'Custom Fields',
          path: '/custom-fields',
          component: () => import('@/views/settings/CustomFields'),
        },
      ];

      if (ALLOWED_SLACK.includes(handle)) {
        tabs.splice(4, 0, {
          label: 'Slack',
          path: '/slack',
          component: () => import('@/views/settings/Slack'),
        });
      }

      return tabs;
    },
  },
  methods: {
    setTabFromRoute() {
      const { tab } = this.$route.params;
      this.tabIndex = this.tabs.map(({ path }) => path).indexOf(`/${tab}`);
    },
  },
  watch: {
    $route() {
      this.setTabFromRoute();
    },
    tabIndex(newIndex) {
      const { hash } = this.$route || {};
      const { path } = this.tabs[newIndex] || {};
      this.$router.push({ params: { tab: path.replace(/^\//, '') }, hash });
    },
  },
};
</script>

<style lang="scss">
.company-settings-page {

  .lead {
    font-size: 1.1rem;
  }

  .settings-form-block {
    border-bottom: 1px solid #eee;

    &:last-child {
      border-bottom: none !important;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/views/settings/index.vue